<template>
    <b-button class="ml-2"
        variant="primary"
        @click.stop="AtualizarDespesa()"
    >
        <span>
            Atualizar despesa
        </span>
    </b-button>
</template>

<script>
export default {
    props: {
        rotaAtualizarDespesa: {
            type: String
        },

        despesaId: {
            type: String
        }
    },
   
    methods: {
        AtualizarDespesa() {
            this.$router.push({
                name: this.rotaAtualizarDespesa,
                param: {
                    despesaId: this.despesaId
                }
            })
        }
    }
}
</script>